import { CSSProperties } from 'react';

export const cardStyle: CSSProperties = {
  borderRadius: 8,
  border: '1px solid #d9d9d9',
  transition: 'box-shadow 0.2s, border-color 0.2s',
};

export const cardBodyStyle: CSSProperties = {
  padding: 12,
};

export const cardContentStyle: CSSProperties = {
  display: 'flex',
  gap: 16,
  alignItems: 'center',
};

export const imageContainerStyle: CSSProperties = {
  flexShrink: 0,
};

export const imageStyle: CSSProperties = {
  borderRadius: 6,
  objectFit: 'cover' as const,
};

export const infoContainerStyle: CSSProperties = {
  flex: 1,
};

export const badgeContainerStyle: CSSProperties = {
  marginBottom: 8,
};

export const getBadgeTextStyle = (isAvaliando: boolean): CSSProperties => ({
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  color: isAvaliando ? '#1890ff' : '#8c8c8c',
});

export const titleStyle: CSSProperties = {
  fontSize: 15,
  display: 'block',
  marginBottom: 4,
};

export const detailsStyle: CSSProperties = {
  fontSize: 13,
  color: '#595959',
};

export const valorStyle: CSSProperties = {
  color: '#262626',
};

export const actionsContainerStyle: CSSProperties = {
  display: 'flex',
  gap: 4,
  marginLeft: 'auto',
};

export const editButtonStyle: CSSProperties = {
  color: '#1890ff',
};

export const formGridStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16,
};

export const mediaQueryStyles = `
  @media (max-width: 640px) {
    .hidden-mobile {
      display: none !important;
    }
  }
`;
